export const store_state_plugin = store => {
  store.subscribe((mutation, state) => {
    console.log('STORE STATE PLUGIN =>')
    console.log(mutation)
    console.log(state)
  })
}